createSetLike